/**
 * Ícone do botão "Mais filtros" (Figma 6037:4508, ícone "adjustments" de 20px).
 * O tamanho vai no `style` inline: o `width`/`height` só como atributo perde para
 * regras globais de `svg` injetadas em runtime.
 */
export function MoreFiltersIcon({
  color,
  size = 20,
}: {
  color?: string;
  size?: number;
}) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", width: size, height: size }}
    >
      <path
        d="M12.7382 11.0824C14.2482 11.0825 15.4756 12.1462 15.8307 13.5449H17.2036C17.6636 13.5452 18.0369 13.9182 18.0369 14.3783C18.0369 14.8383 17.6636 15.2113 17.2036 15.2116H15.8307C15.4757 16.611 14.2484 17.6748 12.7382 17.675C11.2282 17.6749 9.99942 16.6114 9.64415 15.2116H2.80333C2.3431 15.2116 1.97 14.8385 1.97 14.3783C1.97 13.918 2.3431 13.5449 2.80333 13.5449H9.64415C9.99955 12.1458 11.2284 11.0824 12.7382 11.0824ZM12.7382 12.749C11.924 12.7491 11.2067 13.4464 11.2067 14.3783C11.2067 15.3111 11.9241 16.0082 12.7382 16.0083C13.5517 16.0081 14.2682 15.3115 14.2682 14.3783C14.2681 13.446 13.5517 12.7492 12.7382 12.749ZM7.48351 2.32422C8.99357 2.32438 10.2225 3.38832 10.5776 4.78841H17.2036C17.6636 4.78866 18.0369 5.16166 18.0369 5.62174C18.0369 6.08183 17.6636 6.45483 17.2036 6.45508H10.5776C10.2219 7.85389 8.99279 8.91667 7.48351 8.91683C5.97406 8.91678 4.74508 7.85392 4.38943 6.45508H2.80333C2.3431 6.45508 1.97 6.08198 1.97 5.62174C1.97 5.16151 2.3431 4.78841 2.80333 4.78841H4.38943C4.74447 3.38832 5.97326 2.32426 7.48351 2.32422ZM7.48351 3.99089C6.67188 3.99094 5.95614 4.68401 5.95193 5.61279C5.95196 5.61578 5.95275 5.61876 5.95275 5.62174C5.95275 5.62419 5.95195 5.62663 5.95193 5.62907C5.95609 6.55684 6.67162 7.25011 7.48351 7.25016C8.29781 7.24996 9.01508 6.55259 9.01508 5.62093C9.01507 4.6883 8.29763 3.99108 7.48351 3.99089Z"
        fill={color ?? "currentColor"}
      />
    </svg>
  );
}
